<div class="fullscreen-info-panel">
  <span class="close-icon" (click)="closeInfoModal()">
    <mat-icon>close</mat-icon>
  </span>

    <span class="info-header">Details</span>

    <div class="info-details">
        <span class="label">Image:</span>
        <span class="value">{{ image.original_image_name }}</span>

        <span class="label">Dimensions:</span>
        <span class="value">
      {{ image.raster_size_width }} x {{ image.raster_size_height }}
    </span>

        <span class="label">Acquisition Date:</span>
        <span class="value">{{ captureDate }}</span>

        <span class="label">Lat/Lon:</span>
        <span class="value">
      {{ mapCenterCoordinates[1].toFixed(6) }},
            {{ mapCenterCoordinates[0].toFixed(6) }}
    </span>

        <span class="label">Camera Type:</span>
        <span class="value">{{ image.cameratechnology }}</span>
    </div>
</div>
